const scrollAnimation = (target) => {
	$('html, body').animate({
		scrollTop: $(target).offset().top - 40
	}, 800);
}

const scrollTo = () => {
	const $trigger = $('.js-scroll-to-section');

	$trigger.on('click', function (event) {
		const $this = $(this);
		let target;
		if ($this.attr('href') == '#' || $this.attr('href') == '') {
			event.preventDefault();

			target = $this.data('target');
		}

		if ($(target).length) {
			scrollAnimation(target);
		}
	});
}

export default function scrollToSection() {
	scrollTo();
}
